import { Empty, Skeleton } from 'antd';
import { Column } from '@ant-design/charts';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import AccountServices from '../../../../services/account.services';
import _ from 'lodash';

function ValidDriverChart({ globalSettings, selectedNode, t, mainColor }) {
  const [validDriverData, setValidDriverData] = useState([]);
  const getValidDriverCountData = (accountServices, role) => {
    return accountServices
      .listAccounts(
        selectedNode.nodeId,
        { ...(role ? { roles: role } : { login: '' }) },
        { login: 'ASC' },
        1,
        false,
        200
      )
      .then(
        (response) => {
          if (response?.data) {
            if (accountServices.checkError(response)) {
              return 0;
            } else {
              const result = accountServices.getResult(response);

              return result.accountsRows || 0;
            }
          }
        },
        (error) => {
          if (axios.isCancel(error)) {
            //this.logFirer.fireLog('LOG', error);
          } else {
            return 0;
          }
        }
      );
  };
  const getValidDriverData = (accountServices) => {
    setIsValidDriverDataLoaded(false);

    Promise.all([
      getValidDriverCountData(accountServices, 'valid_driver'),
      getValidDriverCountData(accountServices, 'valid_driver_adm'),
    ])
      .then((response) => {
        if (response) {
          setValidDriverData([
            {
              type: t('App.AssignableRole.Role.valid_driver'),
              value: response[0],
            },
            {
              type: t('App.AssignableRole.Role.valid_driver_adm'),
              value: response[1],
            },
          ]);
          setIsValidDriverDataLoaded(true);
        }
      })
      .catch((_) => {
        setIsValidDriverDataLoaded(true);
      });
  };

  const validDriverChartConfig = {
    data: validDriverData,
    xField: 'type',
    yField: 'value',
    seriesField: 'type',
    color: [mainColor, '#01CFCB'],
    label: {
      position: 'middle',
      style: {
        fill: '#FFFFFF',
        opacity: 0.6,
      },
    },
  };
  const [isValidDriverDataLoaded, setIsValidDriverDataLoaded] = useState(false);

  useEffect(() => {
    let env;

    if (_.isString(process.env.REACT_APP_ENV)) {
      env = process.env.REACT_APP_ENV;
    } else {
      env = globalSettings.DefaultEnvironment;
    }

    const accountServices = new AccountServices(
      globalSettings.Environment[env]
    );

    getValidDriverData(accountServices);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNode]);

  const checkDataEmpty = () => validDriverData.filter((data) => data.value > 0);

  return isValidDriverDataLoaded ? (
    checkDataEmpty().length ? (
      <Column {...validDriverChartConfig} />
    ) : (
      <Empty />
    )
  ) : (
    <Skeleton active />
  );
}

export default withTranslation()(ValidDriverChart);
